import React from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";

export function Header() {
    return (
        <header className={ styles.header }>
            <h1>SecretNotes</h1>
            <Link to="/sign-in">Log Out</Link>
        </header>
    )
}